import React, { useState, useEffect } from "react";
import Icon from "components/AppIcon";
import LanguageSwitcher from "LanguageSwitcher";
import { useLanguage } from "../LanguageContext"; // Adjust the import path
import NotificationPopup from "./NotificationPopup"; // Import the NotificationPopup component
import { useSelector, useDispatch } from "react-redux";
// Adjust the import path

const Header = ({ onMenuClick }) => {
  const { direction } = useLanguage(); // Get the current direction from context
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const dispatch = useDispatch();

  const { notifications } = useSelector((state) => state.general);

   let userInfo = JSON.parse(localStorage.getItem("user"));


  const toggleNotificationPopup = () => {
    setIsNotificationOpen((prev) => !prev);
  };

  return (
    <header
      className={`fixed top-0 z-30 bg-white border-b border-gray-200 h-16 w-full ${
        direction === "rtl" ? "right-0" : "left-0"
      }`}
    >
      <div className="flex items-center justify-between h-full px-4 lg:px-6">
        <div className="flex items-center">
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100"
          >
            <Icon name="Menu" size={20} />
          </button>
          <div className="ml-2 lg:ml-0">
            <h2 className="text-lg font-semibold text-gray-900">
              Client Management
            </h2>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          {/* Language Toggle */}
          <LanguageSwitcher />
          <button
            onClick={toggleNotificationPopup}
            className="p-2 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100"
          >
            <Icon name="Bell" size={20} />
          </button>
          {isNotificationOpen && (
            <NotificationPopup
              notifications={notifications}
              onClose={toggleNotificationPopup}
            />
          )}
        
          <div className="flex items-center">
            <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center">
              <Icon name="User " size={16} className="text-white" />
            </div>
            <span
              className={`ml-2 text-sm font-medium text-gray-700 hidden sm:block ${
                direction === "rtl" ? "mr-2" : "ml-2"
              }`}
            >
              {userInfo?.name}
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
